export default __webpack_public_path__ + "static/media/Helm of the Milites Templi.5c8fc763.jpg";